/**
 * @file コンポーネント：フル動画ページポイントコンテンツ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnHandleApiErrors, fnHandleApiSuccess } from "~/src/functions/common";

// 型定義
interface Content {
    currentIndexSlide: number;
    pointContentsImageList: [
        {
            defaultFlg: boolean;
        }
    ];
}

// コンポーネントを返す
export const Pointcontents = (props) => {
    /**
     * ポイントコンテンツの取得
     */
    const [listPointcontents, setListPointcontents] = useState([]);
    useEffect(() => {
        const api =
            "/api/operations/contents/point/" +
            props.operationId +
            "?language=" +
            props.languageCodeOperation;
        fetch(api)
            .then(fnHandleApiErrors)
            .then(fnHandleApiSuccess)
            .then((result) => {
                if (result !== null) {
                    const tempList = Object.values(result.contentList).map(
                        (content: Content) => {
                            let currentIndexSlide = 0;
                            content.pointContentsImageList.forEach(
                                (image, index) => {
                                    if (image.defaultFlg === true) {
                                        currentIndexSlide = index;
                                    }
                                }
                            );
                            content.currentIndexSlide = currentIndexSlide;
                            return content;
                        }
                    );
                    setListPointcontents(tempList);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    /**
     * このポイントを視聴するボタンクリック時の処理
     */
    const fnClickButtonJump = (e, time) => {
        // クリックデフォルト処理をキャンセル
        e.preventDefault();
        if (!window.dataUser.isLogin) {
            // 非ログイン時にログインモーダルを出す
            props.setIsOpenModalLogin(true);
        } else if (
            // 執刀医権限、管理者権限でない有料コンテンツかつ未購入の場合、決済情報ポップアップを強調表示
            props.isEditPage !== true &&
            props.isPaid === true &&
            props.isPurchased === false
        ) {
            props.setIsHighlightPopupPayment(true);
        } else {
            // 上記以外の場合、メインコンテンツをフル動画に切り替え、該当の時間にジャンプ
            props.setSelectedContentsData("fullvideo");
            props.fnJump(time, false);
        }
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnClickButtonJump={fnClickButtonJump}
            listPointcontents={listPointcontents}
        />
    );
};
